<template>
  <div class="text-center">
    <a
      v-if="showPrev"
      href="#"
      style="color:#666"
      class="mt-4 prev"
      @click.prevent="setStep(step - 1)"
    >
      &lt; PREV
    </a>
    <span v-if="step > 1 && step < 4" style="color:#666"> | </span>
    <a
      v-if="showNext"
      href="#"
      style="color:#666"
      class="mt-4 next"
      @click.prevent="setStep(step + 1)"
    >
      NEXT &gt;
    </a>
  </div>
</template>
<script>
export default {
  name: "PrevNextBtns",
  data: function() {
    return {};
  },
  computed: {
    step: {
      get() {
        return this.$store.state.step;
      },
      set(value) {
        this.$store.commit("changeStep", value);
      },
    },
    showPrev: {
      get() {
        return this.showHidePrev();
      },
    },
    showNext: {
      get() {
        return this.showHideNext();
      },
    },
  },
  methods: {
    setStep: function(newStep) {
      this.step = newStep;
    },

    showHideNext: function() {
      let step = this.$store.state.step;
      if (step < 4) {
        return true;
      }
      return false;
    },
    showHidePrev: function() {
      let step = this.$store.state.step;
      if (step > 1 && step < 5) {
        return true;
      }
      return false;
    },
  },
};
</script>
